import styled from 'styled-components';

export const DropdownHeader = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid ${(props) => props.theme.colors.border || '#E5E7EB'};
  background: ${(props) => props.theme.colors.background || '#FFFFFF'};
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 2px solid ${(props) => props.theme.colors.border || '#E5E7EB'};
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: ${(props) => props.theme.colors.textSecondary || '#9CA3AF'};
  }

  &:focus {
    border-color: ${(props) => props.theme.colors.primary || '#4F46E5'};
  }
`;

export const DocumentsList = styled.div`
  max-height: 350px;
  overflow-y: auto;
  padding: 8px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
`;

export const EmptyStateIcon = styled.div`
  margin-bottom: 12px;
`;

export const EmptyStateText = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors.textSecondary || '#6B7280'};
  font-weight: 500;
`;

export const DropdownFooter = styled.div`
  padding: 8px 16px;
  border-top: 1px solid ${(props) => props.theme.colors.border || '#E5E7EB'};
  background: ${(props) => props.theme.colors.backgroundSecondary || '#F9FAFB'};
  position: sticky;
  bottom: 0;
  z-index: 1;
`;

export const DocumentCount = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.textSecondary || '#6B7280'};
  font-weight: 600;
  text-align: center;
`;

